import { installSteps, safetyNotes } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";

export default function InstallSteps() {
  return (
    <section id="install" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-24">
              <span className="text-xs tracking-widest text-accent-700 uppercase">Install Guide</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">APP 安装，按这四步来</h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                从找到入口到确认可用，安装流程其实不复杂。安卓和 iOS 的差别主要集中在系统提示那一步，
                留意页面上的说明就能顺利装好。
              </p>

              <div className="mt-8 rounded-lg border border-background-200 bg-secondary-50 p-5">
                <h3 className="text-sm text-foreground-900 flex items-center gap-2">
                  <i className="ri-lock-2-line text-secondary-700"></i>
                  安装前的三点提醒
                </h3>
                <ul className="mt-4 space-y-3">
                  {safetyNotes.map((note) => (
                    <li key={note.id} className="flex items-start gap-3 text-xs text-foreground-700 leading-relaxed">
                      <i className={`${note.icon} text-secondary-700 mt-0.5`}></i>
                      <span>{note.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>

          <div className="relative">
            <span className="hidden lg:block absolute left-[27px] top-3 bottom-3 w-px bg-background-300"></span>
            <ol className="space-y-6 md:space-y-8">
              {installSteps.map((step, i) => (
                <Reveal key={step.id} delay={i * 90}>
                  <li className="relative flex gap-5">
                    <span className="relative z-10 shrink-0 w-14 h-14 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">
                      {step.no}
                    </span>
                    <div className="rounded-lg border border-background-200 bg-background-100 p-5 flex-1">
                      <h3 className="font-heading text-base text-foreground-950">{step.title}</h3>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}